import React from 'react';
import { CHECKOUT_URL } from '../data/checkout';
import { trackAddToCart } from '../utils/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  subLabel?: string;
  size?: 'md' | 'lg';
  href?: string;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}
export function CtaButton({
  children,
  subLabel,
  size = 'lg',
  href = CHECKOUT_URL,
  className = '',
  onClick
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-5 py-4 text-[13px] sm:px-8 sm:py-5 sm:text-base' : 'px-4 py-3 text-[11.5px] sm:px-6 sm:py-3.5 sm:text-sm';
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (href === CHECKOUT_URL) trackAddToCart();
    onClick?.(event);
  };
  return <a href={href} onClick={handleClick} className={`group inline-flex flex-col items-center justify-center rounded-xl bg-[linear-gradient(135deg,#f0d580,#d4af37_45%,#a8862c)] text-center font-extrabold uppercase tracking-tight text-[#1a1400] shadow-[0_8px_30px_rgba(212,175,55,0.32)] outline-none transition-transform duration-200 animate-cta-glow hover:scale-[1.02] focus-visible:ring-2 focus-visible:ring-gold-light focus-visible:ring-offset-2 focus-visible:ring-offset-ink active:scale-[0.99] ${sizing} ${className}`} data-id="element-154" data-mp="vdd95aofm78i">
      <span className="leading-tight" data-id="element-155" data-mp="3jx763ipzb5tk">{children}</span>
      {subLabel ? <span className="mt-1.5 text-[10px] font-semibold normal-case tracking-normal text-[#1a1400]/70" data-id="element-156" data-mp="3owa10ac8vvnt">
          {subLabel}
        </span> : null}
    </a>;
}